export const setNameToAvatar = (firstname: string, lastname: string) =>  `${lastname.charAt(0)}${firstname.charAt(0)}`;
